$shm_hotkey_mark $mol_view
	label \
	anchor \
	sub / <= label
	attr *
		^
		aria-hidden \true
	style *
		^
		positionAnchor <= anchor
